module.exports = __webpack_public_path__ + "img/icone-admin.f9ea8116.png";